import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

const Footer = () => {
  const services = [
    { name: "Data Entry & Processing", path: "/services/data-entry" },
    { name: "Accounts Payable / Receivable", path: "/services/accounts-payable-receivable" },
    { name: "Back Office Support", path: "/services/back-office-support" },
    { name: "Customer Support", path: "/services/customer-support" },
    { name: "HR Outsourcing", path: "/services/hr-outsourcing" },
    { name: "IT Outsourcing", path: "/services/it-outsourcing" },
    { name: "Virtual Employee", path: "/services/virtual-employee" },
  ];

  const digitalServices = [
    { name: "SEO Services", path: "/services/seo" },
    { name: "Web Development", path: "/services/web-development" },
    { name: "PPC Advertising", path: "/services/ppc" },
    { name: "Social Media", path: "/services/social-media" },
  ];

  return (
    <footer className="bg-[#0F172A] text-slate-300" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <img src="https://customer-assets.emergentagent.com/job_instant-seo-score/artifacts/h319f9hx_Adsolute.png" alt="Adsolute" className="h-9 w-auto mb-4" width="140" height="36" />
            <p className="text-sm text-slate-400 leading-relaxed mb-6">
              Expert business process outsourcing services helping UK businesses save costs and improve operational efficiency.
            </p>
            <div className="flex items-center gap-3">
              <a href="https://www.facebook.com/profile.php?id=61579587053584" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-md bg-slate-800 hover:bg-[#0047AB] flex items-center justify-center transition-colors" data-testid="footer-facebook">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg>
              </a>
              <a href="https://www.instagram.com/adsolute.co.uk" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-md bg-slate-800 hover:bg-[#0047AB] flex items-center justify-center transition-colors" data-testid="footer-instagram">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
              </a>
              <a href="https://www.linkedin.com/company/adsolute-co-uk-limited" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-md bg-slate-800 hover:bg-[#0047AB] flex items-center justify-center transition-colors" data-testid="footer-linkedin">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Outsourcing</h3>
            <ul className="space-y-2.5">
              {services.map((svc) => (
                <li key={svc.path}><Link to={svc.path} className="text-sm text-slate-400 hover:text-white transition-colors">{svc.name}</Link></li>
              ))}
            </ul>
          </div>

          {/* Digital Marketing */}
          <div>
            <h3 className="text-white font-semibold mb-4">Digital Marketing</h3>
            <ul className="space-y-2.5">
              {digitalServices.map((svc) => (
                <li key={svc.path}><Link to={svc.path} className="text-sm text-slate-400 hover:text-white transition-colors">{svc.name}</Link></li>
              ))}
            </ul>
            <h3 className="text-white font-semibold mb-3 mt-6">Company</h3>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-slate-400 hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/blog" className="text-sm text-slate-400 hover:text-white transition-colors">Blog</Link></li>
              <li><Link to="/contact" className="text-sm text-slate-400 hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3"><Phone className="w-4 h-4 text-[#3B82F6] mt-0.5 flex-shrink-0" /><a href="tel:+447481111540" className="text-sm text-slate-400 hover:text-white transition-colors">+44 748 1111 540</a></li>
              <li className="flex items-start gap-3"><Mail className="w-4 h-4 text-[#3B82F6] mt-0.5 flex-shrink-0" /><a href="mailto:helpdesk@adsolute.co.uk" className="text-sm text-slate-400 hover:text-white transition-colors">helpdesk@adsolute.co.uk</a></li>
              <li className="flex items-start gap-3"><MapPin className="w-4 h-4 text-[#3B82F6] mt-0.5 flex-shrink-0" /><span className="text-sm text-slate-400">9 Norton Road, Camberley,<br />England, GU15 1SB</span></li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-5 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-xs text-slate-500">&copy; {new Date().getFullYear()} Adsolute. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/page/privacy-policy" className="text-xs text-slate-500 hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/page/terms-of-service" className="text-xs text-slate-500 hover:text-white transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
